import type { UserProfileUpdateRequestPreferences } from './userProfileUpdateRequestPreferences';
import type { UserProfileUpdateRequestSocialLinks } from './userProfileUpdateRequestSocialLinks';

export interface UserProfileUpdateRequest {
  bio?: string;
  coverImageUrl?: string;
  fullName?: string;
  location?: string;
  preferences?: UserProfileUpdateRequestPreferences;
  profileImageUrl?: string;
  socialLinks?: UserProfileUpdateRequestSocialLinks;
  website?: string;
}
